import { render } from "./EstadosCuenta.vue?vue&type=template&id=84c322b8&scoped=true"
import script from "./EstadosCuenta.vue?vue&type=script&lang=js"
export * from "./EstadosCuenta.vue?vue&type=script&lang=js"

import "./EstadosCuenta.vue?vue&type=style&index=0&id=84c322b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c322b8"]])

export default __exports__